import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Stock from "./pages/Stock";
import Upcoming from "./pages/Upcoming";
import CarDetail from "./pages/CarDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import BuyYourCar from "./pages/BuyYourCar";
import SellMyCar from "./pages/SellMyCar";
import Overname from "./pages/Overname";
import Financing from "./pages/Financing";
import AftersalesCustomization from "./pages/AftersalesCustomization";
import Sold from "./pages/Sold";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminCars from "./pages/admin/AdminCars";
import AdminCarForm from "./pages/admin/AdminCarForm";
import AdminInquiries from "./pages/admin/AdminInquiries";
import AdminSold from "./pages/admin/AdminSold";
import AdminImport from "./pages/admin/AdminImport";
import AdminBidCalculator from "./pages/admin/AdminBidCalculator";
import AdminSales from "./pages/admin/AdminSales";
import AdminRegister from "./pages/admin/AdminRegister";
import AdminDossiers from "./pages/admin/AdminDossiers";
import AdminDossierDetail from "./pages/admin/AdminDossierDetail";
import DossierStatus from "./pages/DossierStatus";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import VacationPopup from "./components/VacationPopup";
import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./i18n/I18nContext";

function RouterContent() {
  const location = useLocation();
  // Check URL fragment synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <VacationPopup />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/stock" element={<Stock />} />
        <Route path="/binnenkort" element={<Upcoming />} />
        <Route path="/listing/:id" element={<CarDetail />} />
        <Route path="/over-ons" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/wij-kopen-uw-auto" element={<BuyYourCar />} />
        <Route path="/verkoop-mijn-auto" element={<SellMyCar />} />
        <Route path="/overname" element={<Overname />} />
        <Route path="/financiering" element={<Financing />} />
        <Route path="/naverkoop-personalisatie" element={<AftersalesCustomization />} />
        <Route path="/verkocht" element={<Sold />} />
        <Route path="/dossier/:token" element={<DossierStatus />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminCars />} />
          <Route path="cars/new" element={<AdminCarForm />} />
          <Route path="cars/:id/edit" element={<AdminCarForm />} />
          <Route path="inquiries" element={<AdminInquiries />} />
          <Route path="sold" element={<AdminSold />} />
          <Route path="register" element={<AdminRegister />} />
          <Route path="dossiers" element={<AdminDossiers />} />
          <Route path="dossiers/:id" element={<AdminDossierDetail />} />
          <Route path="import" element={<AdminImport />} />
          <Route path="bod-calculator" element={<AdminBidCalculator />} />
          <Route path="winst" element={<AdminSales />} />
        </Route>
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <RouterContent />
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
